import { configuration } from '../../../infrastructure/clientConfigurationProvider';
import { encodeObject, buildStringFromParams } from '../../../infrastructure/httpCallUtilities';
import { ICombination } from '../../../types/interfaces';

const HexColorRegex = /^#[0-9A-Fa-f]{6}$/;
export function buildDocUrlForAdjustedSurface(
  documentUrl: string,
  productKey: string,
  productVersion: number,
  substrateColor: string,
  combination: ICombination,
  locale: string
): string {
  const optionSelectionsQueryString = encodeObject(combination, 'optionSelections');
  const surfaceUri = buildSurfaceUri(
    productKey,
    productVersion,
    locale,
    optionSelectionsQueryString
  );
  const params = {
    documentUrl,
    surfaceSpecificationUrl: surfaceUri,
    requester: configuration.requestor,
    ...(substrateColor &&
      HexColorRegex.test(substrateColor) && {
        targetSubstrateColor: `rgb(${substrateColor})`,
      }),
    apiKey: configuration.artworkGenerationApiKey,
  };

  return `${
    configuration.serviceUrls.artworkGenerationUrl
  }v3/adaptation:adjustForSurface?${buildStringFromParams(params)}`;
}

function buildSurfaceUri(
  productKey: string,
  productVersion: number,
  locale: string,
  optionSelectionsQueryString: string
): string {
  return `${configuration.serviceUrls.designSpecificationsUrl}v2/designViews/products/${productKey}/${productVersion}?${optionSelectionsQueryString}&culture=${locale}&requester=${configuration.requestor}`;
}
